import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { APIEndpoints } from "src/types/apiTypes";
import useFetch from "../useFetch";
import { ToastContext } from "src/context/toastContext";
import { ToastTypes } from "src/types";
import { AuthContext } from "src/context/authContext";
import { handleNavigation } from "src/helpers";

const useCaseTransferFunc = ({ redirectAction }: { redirectAction: () => void }) => {
  const { showToast } = useContext(ToastContext);
  const { defaultView } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const redirectDecision = () => {
    const isRedirectRequired = handleNavigation(defaultView, location.pathname);
    if (isRedirectRequired) {
      navigate(defaultView.includes("/") ? defaultView : `/${defaultView}`, { replace: true, state: { _refresh: new Date() } })
    } else {
      redirectAction();
    }
  }

  const { loading: apiInPorgress, mutate: transferCase, data: appealCaseResponse } =
    useFetch<{}>(APIEndpoints.TRANSFER_CASE);

  useEffect(() => {
    if (appealCaseResponse) {
      showToast(["Case transferred Successfully!"], ToastTypes.INFO);
      redirectDecision();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appealCaseResponse]);

  const submitTransferCase = (caseId: number, transfer?: boolean) => {
    const pathParams = {
      caseId: caseId,
    }
    transferCase({}, pathParams, { ...(transfer ? { taskForTransfer: false } : {}) })
  }

  return { submitTransferCase, apiInPorgress };
};

export default useCaseTransferFunc;
